import {useDispatch} from "react-redux"
import {Dispatch} from "redux/store"

export default () => useDispatch<Dispatch>();
